<div class="card card-shadow">
    <div class="card-body pb-0">
        <div class="d-flex justify-content-between border-bottom pb-2 mb-3">
            <h6 class="fw-bold">Notification</h6>
            <div ngbDropdown class="d-inline-block">
                <button class="btn btn-sm rounded-0 btn-outline-default" id="mediaCorner" ngbDropdownToggle>
                    {{ noticeBoardCategory ? noticeBoardCategory?.name : 'ALL' }}
                </button>
                <div ngbDropdownMenu aria-labelledby="mediaCorner">
                    <button (click)="change('')" ngbDropdownItem>ALL</button>
                    <button *ngFor="let item of noticeBoardCategories" (click)="change(item)"
                        ngbDropdownItem>{{item.name}}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body py-2" style="max-height: 482px;overflow-y:auto">
        <ul class="list-unstyled">
            <li *ngFor="let v of queryResult.items" class="media mb-4">
                <div class="media-body">
                    <p class="description mt-0" [innerHtml]="v.content">
                    </p>
                    <div class="d-flex align-items-center">
                        <div *ngIf="v.updatedAt" class="">
                            <span class="mr-2">
                                <i-bs name="calendar3" width="1em" height="1em"></i-bs>
                            </span>
                            <small class="align-middle">{{ v.updatedAt | date }}</small>
                        </div>
                        <div *ngIf="v.mediaFile" class="ml-md-auto">
                            <a target="_blank" href='{{ v.mediaFile.mediaUrl }}' class="btn btn-sm btn-outline-primary">
                                <i-bs name="caret-down-fill" width="1em" height="1em"></i-bs>
                            </a>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
        <div *ngIf="queryResult.items" class="d-flex justify-content-end">
            <a [routerLink]="['/notice-board']"
                class="mt-3 mr-3 btn btn-primary btn-sm">View all</a></div>
    </div>
</div>